(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-abo-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bk-abocard]').forEach((karte) => {
    const quelle = karte.querySelector('[data-bk-abo-data]');
    if (!quelle) return;

    let daten;
    try {
      daten = JSON.parse(quelle.textContent);
    } catch (fehler) {
      return; // Ohne Daten bleibt die serverseitig gerenderte Auszeichnung stehen.
    }

    const varianteFeld = karte.querySelector('[data-bk-variant]');
    const groesse = karte.querySelector('[data-bk-size]');
    const rhythmen = Array.from(karte.querySelectorAll('[data-bk-plan]'));
    const jetzt = karte.querySelector('[data-bk-now]');
    const vorher = karte.querySelector('[data-bk-was]');
    const grund = karte.querySelector('[data-bk-unit]');
    const ersparnis = karte.querySelector('[data-bk-save]');
    const absenden = karte.querySelector('[data-bk-submit]');

    if (!varianteFeld || !jetzt) return;

    const formatierer = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: daten.currency || 'EUR',
    });

    const geld = (cent) => formatierer.format(cent / 100);

    const grundpreis = (cent) => {
      if (!cent || !daten.refUnit) return '';
      const menge = daten.refValue && daten.refValue !== 1 ? daten.refValue + ' ' : '';
      return geld(cent) + '/' + menge + daten.refUnit;
    };

    const gewaehlterPlan = () => {
      const treffer = rhythmen.find((feld) => feld.type !== 'radio' || feld.checked);
      return treffer ? treffer.value : '';
    };

    const auffrischen = () => {
      const variante = daten.variants[varianteFeld.value];
      if (!variante) return;

      const plan = variante.plans ? variante.plans[gewaehlterPlan()] : null;
      const preis = plan ? plan.price : variante.price;
      const durchgestrichen = plan ? variante.price : variante.compare;
      const gespart = plan ? variante.price - plan.price : 0;

      // Der Grundpreis muss zum ausgezeichneten Preis passen. Liefert die
      // Zustellung keinen eigenen, rechnen wir ihn mit derselben Formel wie
      // Shopify aus Preis und Füllmenge — nicht aus dem gerundeten Grundpreis
      // der Variante, das wäre bis zu einen Cent daneben.
      let einheit = plan ? plan.unit : variante.unit;
      if (!einheit && variante.qty > 0) {
        einheit = Math.round((preis * (daten.refValue || 1)) / variante.qty);
      }

      jetzt.textContent = geld(preis);

      if (vorher) {
        if (durchgestrichen && durchgestrichen > preis) {
          vorher.textContent = geld(durchgestrichen);
          vorher.hidden = false;
        } else {
          vorher.hidden = true;
        }
      }

      if (grund) grund.textContent = grundpreis(einheit);

      if (ersparnis) {
        if (gespart > 0) {
          ersparnis.textContent = geld(gespart) + ' gespart';
          ersparnis.hidden = false;
        } else {
          ersparnis.hidden = true;
        }
      }

      if (absenden) absenden.disabled = variante.available === false;
    };

    if (groesse) {
      groesse.addEventListener('change', () => {
        varianteFeld.value = groesse.value;
        auffrischen();
      });
    }

    rhythmen.forEach((feld) => feld.addEventListener('change', auffrischen));

    auffrischen();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-email-capture"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bk-email-capture]').forEach((section) => {
    if (section.dataset.popupEnabled !== 'true') return;

    const dialog = section.querySelector('[data-bk-email-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const storageKey = 'bkEmailCaptureDismissedAt';
    const lastDismissed = Number(localStorage.getItem(storageKey) || 0);
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;
    if (Date.now() - lastDismissed < fourteenDays) return;

    const close = () => {
      localStorage.setItem(storageKey, String(Date.now()));
      dialog.close();
    };

    section.querySelectorAll('[data-bk-email-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    window.setTimeout(() => {
      if (!dialog.open) dialog.showModal();
    }, 8000);

    document.addEventListener('mouseleave', (event) => {
      if (event.clientY <= 0 && !dialog.open) dialog.showModal();
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bk-cookie]').forEach((knopf) => {
    const bereit = () =>
      typeof window.privacyBanner === 'object' &&
      window.privacyBanner !== null &&
      typeof window.privacyBanner.showPreferences === 'function';

    const zeigen = () => {
      if (!bereit()) return false;
      knopf.hidden = false;
      return true;
    };

    // Shopify lädt das Banner-Skript asynchron. Ein paar Sekunden nachfassen,
    // danach gibt es keins — dann bleibt der Knopf verborgen.
    if (!zeigen()) {
      let versuche = 0;
      const takt = setInterval(() => {
        versuche += 1;
        if (zeigen() || versuche >= 20) clearInterval(takt);
      }, 500);
    }

    knopf.addEventListener('click', () => {
      if (bereit()) window.privacyBanner.showPreferences();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-product-cro"] && !Shopify.designMode) return;
  try {
    
  const stickyRoots = document.querySelectorAll('[data-bk-product-cro]');
  stickyRoots.forEach((root) => {
    const sticky = root.querySelector('[data-bk-sticky-atc]');
    const button = root.querySelector('[data-bk-sticky-atc-button]');
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const submitButton = productForm ? productForm.querySelector('[type="submit"], button[name="add"]') : null;

    if (!sticky || !button || !productForm || !submitButton) return;

    button.addEventListener('click', () => {
      submitButton.click();
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.hidden = entry.isIntersecting;
      });
    }, { threshold: 0.1 });

    observer.observe(submitButton);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-product-revenue-stack"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bk-revenue]').forEach((root) => {
    const currency = root.dataset.currency || 'EUR';
    const locale = root.dataset.locale || document.documentElement.lang || 'de-DE';
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });

    const formatMoney = (cents) => formatter.format(cents / 100);
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const productVariantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    const quantityInput = productForm ? productForm.querySelector('input[name="quantity"]') : null;
    const submitButton = productForm ? productForm.querySelector('[type="submit"], button[name="add"]') : null;

    root.querySelectorAll('[data-bk-quantity-preset]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantityInput || !submitButton) return;
        quantityInput.value = button.dataset.bkQuantityPreset || '1';
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        submitButton.click();
      });
    });

    const subscriptionButton = root.querySelector('[data-bk-scroll-subscription]');
    subscriptionButton?.addEventListener('click', () => {
      const subscription = document.querySelector('.shopify_subscriptions_fieldset, [data-shopify-app-block*="subscriptions"]');
      subscription?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    const bundle = root.querySelector('[data-bk-bundle]');
    if (!bundle) return;

    const totalTarget = bundle.querySelector('[data-bk-bundle-total]');
    const message = bundle.querySelector('[data-bk-bundle-message]');
    const addButton = bundle.querySelector('[data-bk-bundle-add]');
    const items = Array.from(bundle.querySelectorAll('[data-bk-bundle-item]'));
    const currentBundleItem = bundle.querySelector('[data-bk-current-item]');

    const updateTotal = () => {
      const total = items.reduce((sum, item) => {
        if (item.checked) return sum + Number(item.dataset.price || 0);
        return sum;
      }, 0);
      if (totalTarget) totalTarget.textContent = formatMoney(total);
    };

    items.forEach((item) => item.addEventListener('change', updateTotal));
    updateTotal();

    document.addEventListener('variant:update', (event) => {
      const variant = event.detail?.resource;
      if (!variant || !currentBundleItem) return;

      currentBundleItem.dataset.variantId = variant.id;
      if (variant.price) currentBundleItem.dataset.price = variant.price;
      updateTotal();
    });

    addButton?.addEventListener('click', async () => {
      const selectedItems = items
        .filter((item) => item.checked)
        .map((item) => {
          const id = item.hasAttribute('data-bk-current-item') && productVariantInput
            ? productVariantInput.value
            : item.dataset.variantId;

          return { id: Number(id), quantity: 1 };
        })
        .filter((item) => item.id);

      if (!selectedItems.length) return;

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((component) => component.dataset.sectionId)
        .filter(Boolean);

      addButton.disabled = true;
      if (message) message.textContent = '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selectedItems, sections: sectionIds.join(',') }),
        });
        const data = await response.json();

        if (!response.ok) throw new Error(data.description || data.message || 'Bundle konnte nicht hinzugefügt werden.');

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'bk-product-revenue-stack',
            data: { source: 'bk-product-revenue-stack', sections: data.sections || {} },
          },
        }));

        if (message) message.textContent = 'Set wurde in den Warenkorb gelegt.';
      } catch (error) {
        if (message) message.textContent = error.message;
      } finally {
        addButton.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
